import styled from "@emotion/styled";
import { Avatar } from "@mui/material";

type Props = {
  className?: string;
  userName: string;
  userAvatar?: string | null;
};

const CustomAvatar = styled(Avatar)`
  background-color: #e2e2e2; //TODO: use from theme
  color: #6a6a6a; //TODO: use from theme
  font-size: ${(p) => p.theme.text.fontSizes.l};
`;

export const UserAvatar = (props: Props) => {
  const { className, userName, userAvatar } = props;
  const userNameParts = userName.split(" ");
  const firstInitial = userNameParts[0]?.[0] || "";
  const secondInitial = userNameParts[1]?.[0] || "";
  const initials = `${firstInitial}${secondInitial}` || firstInitial;
  return (
    <CustomAvatar className={className} src={userAvatar ?? ""} alt={userName}>
      {initials}
    </CustomAvatar>
  );
};
